export default {
  bmProButtonText: {
    id: 'header_bm_pro_button_text',
    defaultMessage: 'Business',
  },
}
